export const USER_SETTINGS_STORAGE_KEY = 'playerSettings';

export class UserSettingsStorage {
  #userKey = '';
  #data = {};

  constructor(userId, profileId) {
    this.#userKey = `${userId}_${profileId}`;
    try {
      this.#data = JSON.parse(
        window.localStorage.getItem(USER_SETTINGS_STORAGE_KEY) || '{}'
      );
    } catch (error) {
      // eslint-disable-next-line no-console
      console.error(error);
    }
  }

  getAudioByVideoId = (videoId) => {
    return this.getItem('audio')?.[videoId];
  };
  setAudioByVideoId = (videoId, audioId) => {
    let audio = this.getItem('audio');
    if (!audio) {
      audio = {};
    }
    audio[videoId] = audioId;
    this.setItem('audio', audio);
  };

  getLastAudio = () => {
    return this.getItem('lastAudio');
  };
  setLastAudio = (audioId) => {
    this.setItem('lastAudio', audioId);
  };

  getSubtitles = () => {
    return this.getItem('subtitles');
  };
  setSubtitles = (subtitlesId) => {
    this.setItem('subtitles', subtitlesId);
  };

  getQuality = () => {
    return this.getItem('quality');
  };
  setQuality = (qualityId) => {
    this.setItem('quality', qualityId);
  };

  getVolume = () => {
    return this.getItem('volume');
  };
  setVolume = (volume) => {
    this.setItem('volume', volume);
  };

  getMuted = () => {
    return this.getItem('muted');
  };
  setMuted = (isMuted) => {
    this.setItem('muted', isMuted);
  };

  getItem = (key) => {
    return this.#getUserSettings()[key];
  };

  setItem = (key, value) => {
    const settings = this.#getUserSettings();
    settings[key] = value;
    this.#savetUserSettings(settings);
  };

  #getUserSettings = () => {
    return this.#data[this.#userKey] || {};
  };

  #savetUserSettings = (settings) => {
    try {
      this.#data = {
        ...this.#data,
        [this.#userKey]: settings,
      };
      window.localStorage.setItem(
        USER_SETTINGS_STORAGE_KEY,
        JSON.stringify(this.#data)
      );
    } catch (error) {
      // eslint-disable-next-line no-console
      console.error(error);
    }
  };
}
